import { useFetch, usePatch, usePost } from '@selfserve/react-hooks';
import { apiEndpoints, IIndexSignature } from '@selfserve/react-utils';

import { CatalogItems, Package, Plan } from './interfaces';

export const useCatalogItemsRequest = () =>
  useFetch<CatalogItems>(apiEndpoints.catalogItems, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

export const usePlanItemRequest = (name: string, enabled: boolean) =>
  useFetch<Plan>(apiEndpoints.planItem.replace(':name', name), undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled,
  });

export const usePlanItemUpdateRequest = (name: string) =>
  usePatch<Plan, Plan>(apiEndpoints.planItem.replace(':name', name));

export const usePackageItemListRequest = (name: string, enabled: boolean) => {
  const packageList = useFetch<Package[]>(
    apiEndpoints.packageList,
    { name },
    {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled,
    }
  );

  let result: any = packageList;
  if (packageList?.data && packageList?.data?.data) {
    result = {
      ...packageList,
      data: {
        ...packageList.data,
        data: packageList.data.data[0],
      },
    };
  }
  return result;
};

export const usePackageItemUpdateRequest = (name: string) =>
  usePatch<Package, Package>(
    apiEndpoints.packageItemUpdate.replace(':name', name)
  );

export const usePackageItemCreateRequest = () =>
  usePost<Package, Package>(
    apiEndpoints.packageItemCreate
  );

export const usePartnersRequest = (params: IIndexSignature<string | number | string[]>) =>
  useFetch<any>(
    apiEndpoints.partners,
    params,
    {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: !!params['pageSize'] && +params['pageIndex'] >= 0,
    }
  );

export const useChecklistsRequest = (params: IIndexSignature<string | number | string[]>) =>
  useFetch<any>(
    apiEndpoints.checklists,
    params,
    {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: params['partner_id'] !== undefined && !!params['pageSize'] && +params['pageIndex'] >= 0,
    }
  );

export const useAnnouncementsRequest = (params: IIndexSignature<string | number | string[]>) =>
  useFetch<any>(
    apiEndpoints.checklists,
    params,
    {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: params['type'] === 'announcement' && !!params['pageSize'] && +params['pageIndex'] >= 0,
    }
  );

export const useSubscriptionsRequest = (params: IIndexSignature<string | number | string[]>) =>
  useFetch<any>(
    apiEndpoints.subscriptions,
    params,
    {
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      enabled: !!params['pageSize'] && +params['pageIndex'] >= 0,
    }
  );

export const useExtendSubscriptionDate = (subscriptionId: string) =>
  usePost<any, any>(
    apiEndpoints.extendPlanDate.replace(':subscriptionId', subscriptionId)
  );

export * from './interfaces';
export * from './schemas';
